import styled from "styled-components"

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 0.5rem;
  gap: 0.5rem;
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;

  svg {
    height: 1.4rem;
    width: 1.4rem;
    fill: ${({ theme }) => theme.colors.greyDark};
  }
`

export const AttributeTag = styled.div`
  background: ${({ theme }) => theme.colors.greyLight};
  padding: 0.2rem 0.8rem;
  border-radius: 0.4rem;
  font-weight: 700;
  font-size: 1.1rem;
  white-space: nowrap;
`
